import { AxiosRequestConfig } from 'axios'
import { ActionType as CommonActionType } from 'store/common/model'
import { history, store } from 'store/configureStore'
import { RETRY_COUNT_502 } from '../consts'

import { EVENT_EMITTER, EVENTS_NAME, NgApiClient } from '@centra/centra-ui'
import { IResponse } from '@centra/centra-ui/dist/api/restClient/models'
import { IUnitEventDetails, TUnitEventType } from '@centra/centra-ui/dist/core/Unit/models'

export const API_URL = process.env.REACT_APP_GENERAL_API_ENDPOINT!
export const AUTH_API_ENDPOINT = process.env.REACT_APP_AUTH_API_ENDPOINT!
export const COOKIE_NAME = process.env.REACT_APP_AUTH_COOKIE_NAME || '_cen_t_dev'
export const UI_BASE_URL = process.env.REACT_APP_UI_BASE_URL!
export const PLATFORM_BASE_URL = process.env.REACT_APP_UI_PLATFORM_BASE_URL!
export const GTM_CONTAINER_ID = process.env.REACT_APP_GTM_CONTAINER_ID
export const XAPILIB_URL = process.env.REACT_APP_XAPILIB_URL!

export const NG_API_CLIENT = new NgApiClient({
  uiBaseUrl: UI_BASE_URL,
  authUrl: AUTH_API_ENDPOINT,
  cookieName: COOKIE_NAME,
  apiUrl: API_URL,
  platformUrl: PLATFORM_BASE_URL,
  xapilbUrl: XAPILIB_URL,
})

export interface IAxiosRequestConfig extends AxiosRequestConfig {
  apiType?: 'general' | 'task' | 'product'
}

let retryAttempt = 0

let delay = 0

const errorHandler = async (error: any) => {
  const handleError = (): Promise<any> => {
    NG_API_CLIENT.restClient.instance.interceptors.response.eject(restClientResponse)
    switch (error?.response?.status) {
      case 403:
      case 500:
        history.push('/oops')
        break
      case 400:
        break
      case 404:
        history.push('/404')
        break
      default:
        store.dispatch({
          type: CommonActionType.SET_NOTIFICATION,
          payload: {
            status: 'error',
            title: 'Возникла ошибка.',
            message: `
            Пожалуйста, сообщите об ошибке вашему аккаунт-менеджеру в задаче или напишите нам на <a class="link" href="mailto:notify@centra.ai">notify@centra.ai</a>
          `,
          },
        })
    }

    return Promise.reject(error)
  }
  if (error?.response?.status >= 400 && error?.response?.status < 500) return handleError()

  /** Делаем серию повторных запросов при статусах >= 500 */
  return new Promise((resolve, reject) => {
    if (retryAttempt >= RETRY_COUNT_502) {
      retryAttempt = 0
      return handleError()
    }

    // По условию задержка не должна превышать 5сек
    delay = delay > 5 ? 5 : delay
    delay *= 1000

    retryAttempt++

    setTimeout(async () => {
      try {
        const result = await NG_API_CLIENT.restClient.instance.request(error.config)
        return resolve(result)
      } catch (e) {
        return reject(error)
      }
    }, delay)
  })
}

const restClientResponse = NG_API_CLIENT.restClient.instance.interceptors.response.use(
  response => response,
  errorHandler
)
NG_API_CLIENT.restClient.instance.interceptors.response.use(
  res => res,
  (error: IResponse) => {
    try {
      const httpStatus = String(error?.response?.status)
      if (httpStatus !== '401') {
        const details: IUnitEventDetails = {
          dataId: 'httpError',
          kind: 'internalStat' as TUnitEventType,
          kindData: {
            status: httpStatus,
            error: JSON.stringify(error),
            url: error?.config?.url as string,
            req: JSON.stringify({
              url: error?.config?.url,
              data: error?.config?.data,
              method: error?.config?.method,
              params: error?.config?.params,
            }),
            res: JSON.stringify({
              responseText: error?.response?.responseText,
              response: error?.response?.response,
              responseURL: error?.response?.responseURL,
              statusText: error?.response?.statusText,
              // @ts-ignore
              data: JSON.stringify(error?.response?.data),
            }),
          },
        }

        EVENT_EMITTER.emit(EVENTS_NAME.UNIT_EVENT_LOG, {
          details,
          unit: 'root',
        })
      }
    } catch (e) {
      console.error(e)
    }

    return error
  }
)

export const createApiCall = ({
  apiType = 'general',
  method = 'GET',
  url = '',
  data = {},
  ...rest
}: IAxiosRequestConfig) => {
  switch (apiType) {
    default:
      return (
        NG_API_CLIENT.restClient.instance
          //@ts-ignore
          .request({ method, url, data, ...rest })
          .then(response => response)
          .catch(error => error.response)
      )
  }
}
